import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import { Form, Alert, Col, Row } from "react-bootstrap";
import LoadingSpinner from "./LoadingSpinner";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { addUser, deleteUser, updateUser } from "../../../actions";

const UserList = (props) => {
  const useStyles = makeStyles({
    root: {
      "& .super-app-theme--header": {
        backgroundColor: "rgba(255, 7, 0, 0.55)",
      },
      "& .super-app-theme--cell": {
        backgroundColor: "rgba(224, 183, 60, 0.55)",
        color: "#1a3e72",
        fontWeight: "600",
      },
      "& .super-app.negative": {
        backgroundColor: "rgba(157, 255, 118, 0.49)",
        color: "#1a3e72",
        fontWeight: "600",
      },
      "& .super-app.positive": {
        backgroundColor: "#d47483",
        color: "#1a3e72",
        fontWeight: "600",
      },
    },
  });
  const classes = useStyles();
  function formatDate(input) {
    let getDate = new Date(input).getDate();
    let getMonth = new Date(input).getMonth() + 1;
    let getYear = new Date(input).getFullYear();
    return getMonth + "/" + getDate + "/" + getYear;
  }
  var dateInPast = function (firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }
    return false;
  };

  var dateInFuture = function (firstDate, secondDate) {
    if (firstDate.setHours(0, 0, 0, 0) >= secondDate.setHours(0, 0, 0, 0)) {
      return true;
    }
    return false;
  };
  const userID = localStorage.getItem("id");
  const auth = localStorage.getItem("auth");
  const [alertMsg, setAlertMsg] = useState({
    deleteApiResMsg: "",
    deleteUserAPIError: "",
    updateApiResStatusCode: "",
    updateUserAPIError: "",
    mandatoryFileds: "",
    userAlreadyRegistered: "",
  });

  //const [roles, setRole] = React.useState();

  const [subscriptions, setsubscription] = React.useState();
  const [clickedRowID, setClickedRowID] = React.useState();
  const [expiryDate, setExpirationDate] = React.useState();
  const [userRole, setUserRole] = React.useState();
  const [alertBox, setAlertBox] = useState({
    show: true,
    variant: "success",
    msg: "User Data",
  });
  const [userData, setUserData] = useState({
    email: "",
    company: "",
    firstName: "",
    lastName: "",
    phone: "",
    position: "",
    userSubscription: { Trial: false, Ultimate: false, UltimatePlus: false },
    role: "",
  });

  const handleChangeRole = (event) => {
    setUserRole(event.target.value);
    //localStorage.setItem("role", event.target.value);
  };

  const resetAlertBox = () => {
    setAlertBox({
      show: true,
      variant: "success",
      msg: "User Data",
    });
  };

  /* setTimeout(resetAlertBox, 4000); */

  const handleChangeSubscription = (event) => {
    setsubscription(event.target.value);
    // localStorage.setItem("subscription", event.target.value);
  };

  const columns = [
    {
      field: "role",
      width: 110,
      // editable: true,
      renderCell: (params) => {
        return (
          <Select
            defaultValue={params.value ? params.value : " "}
            // value={roles}
            onChange={handleChangeRole}
          >
            <MenuItem value="admin">admin</MenuItem>
            <MenuItem value="user">user</MenuItem>
          </Select>
        );
      },
      renderHeader: () => (
        <strong>
          {"Role "}
          <svg
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path
              fillRule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>{" "}
        </strong>
      ),
    },
    {
      field: "subscription",
      width: 165,
      // editable: true,
      renderCell: (params) => {
        return (
          <Select
            defaultValue={params.value ? params.value : " "}
            // value={roles}
            onChange={handleChangeSubscription}
          >
            <MenuItem value="trial">trial</MenuItem>
            <MenuItem value="ultimate">ultimate</MenuItem>
            <MenuItem value="ultimatePlus">ultimatePlus</MenuItem>
          </Select>
        );
      },
      renderHeader: () => (
        <strong>
          {"Subscription "}
          <svg
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path
              fillRule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>{" "}
        </strong>
      ),
    },
    {
      field: "expired",
      headerName: "Expiration",
      width: 93,
      // type: "boolean",
      description: "Account status.",
      cellClassName: (params) =>
        clsx("super-app", {
          negative: params.row.expired === "active",
          positive: params.row.expired === "inactive",
        }),
      valueFormatter: (params) => {
        if (params.row.expired == true) {
          params.row.expired = "inactive";
          return params.row.expired;
        }
        if (!params.row.expired || params.row.expired == false) {
          params.row.expired = "active";
          return params.row.expired;
        }
      },
    },
    {
      field: "registrationDate",
      headerName: "Registration",
      width: 120,
      type: "date",
      description: "Account Creation Date.",

      valueFormatter: (params) => {
        let getDateOrignalFormat = params.getValue("registrationDate");
        return formatDate(getDateOrignalFormat);
      },
    },
    {
      field: "expirationDate",
      width: 150,
      type: "date",
      editable: true,
      // headerClassName: "super-app-theme--header",
      cellClassName: (params) =>
        clsx("super-app", {
          positive: dateInPast(new Date(params.value), new Date()),
          negative: dateInFuture(new Date(params.value), new Date()),
        }),

      renderHeader: () => (
        <strong>
          {"Expiry date"}
          <svg
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-pencil-square"
            viewBox="0 0 16 16"
          >
            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
            <path
              fillRule="evenodd"
              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
            />
          </svg>{" "}
        </strong>
      ),
      valueFormatter: (params) => {
        let getDateOrignalFormat = params.getValue("expirationDate");
        return formatDate(getDateOrignalFormat);
      },
    },
    {
      field: "fullName",
      headerName: "Full name",
      sortable: true,
      width: 160,
      valueGetter: (params) =>
        `${params.getValue("firstName") || ""} ${
          params.getValue("lastName") || ""
        }`,
    },
    { field: "email", headerName: "Email", width: 230 },
    { field: "domains", headerName: "UE Walkthrough", width: 200 },
    { field: "topics", headerName: "Topics of interest", width: 550 },
    {
      field: "refererId",
      headerName: "Referer",
      width: 124,
      description: "To check the referer traffic.",
    },
    { field: "company", headerName: "Company", width: 130 },
    { field: "phone", headerName: "Phone", width: 130 },
    { field: "position", headerName: "Position", width: 250 },
  ];

  const rows = props.userDataObject;

  const deleteUserByID = async () => {
    //let id = localStorage.getItem("clickedRowID");
    let getClickedRowID = clickedRowID;
    if (getClickedRowID) {
      let res = await deleteUser(getClickedRowID);
      if (res.success) {
        setAlertMsg({ deleteApiResMsg: res.msg });
        setTimeout(function () {
          window.location.reload(); //wait 5 seconds then refresh window to fetch latest user list
        }, 5000);
      } else {
        setAlertMsg({
          deleteUserAPIError: "Internal Server problem, please try again later",
        });
      }

      // axios
      //   .delete(`private/${id}`, {
      //     headers: {
      //       "auth-token": auth,
      //       uid: userID,
      //     },
      //   })
      //   .then((response) => {
      //     setAlertMsg({ deleteApiResMsg: response.data.msg });
      //     setTimeout(function () {
      //       window.location.reload(); //wait 5 seconds then refresh window to fetch latest user list
      //     }, 5000);
      //   })
      //   .catch(() => {
      //     setAlertMsg({
      //       deleteUserAPIError:
      //         "Internal Server problem, please try again later",
      //     });
      //   });
      //localStorage.removeItem("clickedRowID");
    }
  };

  const [validated, setValidated] = useState(false);
  const [role, setRole] = useState("User");
  const [Subscription, setSubscription] = useState("Trial");

  const handleChange = async (e) => {
    const newData = { ...userData };
    newData[e.target.id] = e.target.value;
    setUserData(newData);
  };

  const submitForm = async (e) => {
    if (
      userData.email != "" &&
      userData.firstName != "" &&
      userData.lastName != ""
    ) {
      const form = e.currentTarget;
      if (form.checkValidity() === false) {
        e.preventDefault();
        e.stopPropagation();
      }
      setValidated(true);

      e.preventDefault();
      let res = await addUser({
        email: userData.email.toLowerCase(), //always convert email into lower case,
        company: userData.company,
        firstName: userData.firstName,
        lastName: userData.lastName,
        phone: userData.phone,
        position: userData.position,
        subscription: Subscription,
        role: role,
        // subscription: Object.keys(userData.subscription).filter(
        //   (k) => userData.subscription[k] === true
        // ),
        // // message: message,
        // role: Object.keys(userData.role).filter((k) => userData.role[k] === true),
      });

      if (res.success) {
        setAlertMsg({ updateApiResStatusCode: true });
        setTimeout(function () {
          window.location.reload(); //wait 5 seconds then refresh window to fetch latest user list
        }, 5000);
      } else {
        setAlertMsg({
          updateUserAPIError: "Internal Server problem, please try again later",
        });
        setAlertMsg({
          userAlreadyRegistered: true,
        });
      }
    } else {
      setAlertMsg({ mandatoryFileds: true });
    }
  };

  const updateUserByID = async () => {
    let getExpirationDate = expiryDate;
    if (getExpirationDate) {
      var expired = false;
    }
    let getClickedRowID = clickedRowID;
    if (getClickedRowID) {
      let res = await updateUser(getClickedRowID, {
        subscription: subscriptions,
        expirationDate: getExpirationDate,
        role: userRole,
        expired: expired,
      });
      if (res.success) {
        setAlertMsg({ updateApiResStatusCode: res.success });
        setTimeout(function () {
          window.location.reload(); //wait 5 seconds then refresh window to fetch latest user list
        }, 5000);
      } else {
        setAlertMsg({
          updateUserAPIError: "Internal Server problem, please try again later",
        });
      }

      // axios
      //   .put(`private/${localStorage.getItem("clickedRowID")}`, {
      //     headers: {
      //       uid: userID,
      //     },
      //     subscription: subscriptions,
      //     expirationDate: localStorage.getItem("expirationDate"),
      //     role: roles,
      //     expired: expired,
      //   })
      //   .then((response) => {
      //     setAlertMsg({ updateApiResStatusCode: response.status });
      //     setTimeout(function () {
      //       window.location.reload(); //wait 5 seconds then refresh window to fetch latest user list
      //     }, 5000);
      //   })
      //   .catch(() => {
      //     setAlertMsg({
      //       updateUserAPIError:
      //         "Internal Server problem, please try again later",
      //     });
      //   });

      //localStorage.removeItem("clickedRowID");
      //localStorage.removeItem("expirationDate");
      //localStorage.removeItem("subscription");
      //localStorage.removeItem("role");
    }
  };

  return (
    <div className="container-fluid nav_bg my-3 ">
      <div className="row ">
        {props.userRole === "admin" && auth !== null && auth !== undefined && (
          <div className="col-12 mx-auto">
            <Alert
              show={props.alertBox.show}
              variant={props.alertBox.variant}
              align="center"
            >
              {props.alertBox.msg}
              <svg
                style={{ float: "right", cursor: "pointer" }}
                width="45"
                height="25"
                fill="currentColor"
                viewBox="0 0 16 16"
                href="#addUser"
                data-toggle="modal"
                className="bi bi-plus-circle-dotted"
              >
                <title>Create new user</title>
                <path d="M8 0c-.176 0-.35.006-.523.017l.064.998a7.117 7.117 0 0 1 .918 0l.064-.998A8.113 8.113 0 0 0 8 0zM6.44.152c-.346.069-.684.16-1.012.27l.321.948c.287-.098.582-.177.884-.237L6.44.153zm4.132.271a7.946 7.946 0 0 0-1.011-.27l-.194.98c.302.06.597.14.884.237l.321-.947zm1.873.925a8 8 0 0 0-.906-.524l-.443.896c.275.136.54.29.793.459l.556-.831zM4.46.824c-.314.155-.616.33-.905.524l.556.83a7.07 7.07 0 0 1 .793-.458L4.46.824zM2.725 1.985c-.262.23-.51.478-.74.74l.752.66c.202-.23.418-.446.648-.648l-.66-.752zm11.29.74a8.058 8.058 0 0 0-.74-.74l-.66.752c.23.202.447.418.648.648l.752-.66zm1.161 1.735a7.98 7.98 0 0 0-.524-.905l-.83.556c.169.253.322.518.458.793l.896-.443zM1.348 3.555c-.194.289-.37.591-.524.906l.896.443c.136-.275.29-.54.459-.793l-.831-.556zM.423 5.428a7.945 7.945 0 0 0-.27 1.011l.98.194c.06-.302.14-.597.237-.884l-.947-.321zM15.848 6.44a7.943 7.943 0 0 0-.27-1.012l-.948.321c.098.287.177.582.237.884l.98-.194zM.017 7.477a8.113 8.113 0 0 0 0 1.046l.998-.064a7.117 7.117 0 0 1 0-.918l-.998-.064zM16 8a8.1 8.1 0 0 0-.017-.523l-.998.064a7.11 7.11 0 0 1 0 .918l.998.064A8.1 8.1 0 0 0 16 8zM.152 9.56c.069.346.16.684.27 1.012l.948-.321a6.944 6.944 0 0 1-.237-.884l-.98.194zm15.425 1.012c.112-.328.202-.666.27-1.011l-.98-.194c-.06.302-.14.597-.237.884l.947.321zM.824 11.54a8 8 0 0 0 .524.905l.83-.556a6.999 6.999 0 0 1-.458-.793l-.896.443zm13.828.905c.194-.289.37-.591.524-.906l-.896-.443c-.136.275-.29.54-.459.793l.831.556zm-12.667.83c.23.262.478.51.74.74l.66-.752a7.047 7.047 0 0 1-.648-.648l-.752.66zm11.29.74c.262-.23.51-.478.74-.74l-.752-.66c-.201.23-.418.447-.648.648l.66.752zm-1.735 1.161c.314-.155.616-.33.905-.524l-.556-.83a7.07 7.07 0 0 1-.793.458l.443.896zm-7.985-.524c.289.194.591.37.906.524l.443-.896a6.998 6.998 0 0 1-.793-.459l-.556.831zm1.873.925c.328.112.666.202 1.011.27l.194-.98a6.953 6.953 0 0 1-.884-.237l-.321.947zm4.132.271a7.944 7.944 0 0 0 1.012-.27l-.321-.948a6.954 6.954 0 0 1-.884.237l.194.98zm-2.083.135a8.1 8.1 0 0 0 1.046 0l-.064-.998a7.11 7.11 0 0 1-.918 0l-.064.998zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
              </svg>
              <div id="addUser" className="modal fade">
                <div className="modal-dialog">
                  <div className="modal-content" style={{ padding: "2vw" }}>
                    {alertMsg.updateApiResStatusCode ? (
                      <Alert variant="success" align="center">
                        New user created successfully, this page will be
                        automatically reloaded after 5 seconds...
                      </Alert>
                    ) : alertMsg.mandatoryFileds ? (
                      <Alert variant="danger" align="center">
                        Please enter the mandatory fileds
                      </Alert>
                    ) : alertMsg.userAlreadyRegistered ? (
                      <Alert variant="danger" align="center">
                        Email is already registerd
                      </Alert>
                    ) : (
                      <div></div>
                    )}

                    <Form validated={validated}>
                      {/* <Alert
                      show={props.alertBox.show}
                      variant={props.alertBox.variant}
                      align="center"
                      > */}
                      {/* {alertForm.msg} */}

                      {/* </Alert> */}
                      {/* {alertMsg.insertApiResStatusCode ? (
                        <Alert variant="success" align="center">
                          The new user has been added successfully, this page
                          will be automatically reloaded after 5 seconds...
                        </Alert>
                      ) : alertMsg.insertDomainAPIError ? (
                        <Alert
                          className="alert alert-danger alert-dismissible fade inn"
                          variant="danger"
                          align="center"
                        >
                          {alertMsg.insertDomainAPIError}
                        </Alert>
                      ) : (
                        <div></div>
                      )} */}
                      <div
                        className="modal-header"
                        style={{ padding: 0, marginBottom: "2vh" }}
                      >
                        <h4 className="modal-title">Create New User</h4>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-hidden="true"
                        >
                          &times;
                        </button>
                      </div>

                      <Form.Group style={{ textAlign: "left" }} id="email">
                        <Form.Label>Business E-Mail*</Form.Label>
                        <Form.Control
                          id="email"
                          type="email"
                          name="email"
                          placeholder="E-mail"
                          defaultValue={userData.email}
                          onChange={handleChange}
                          required
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group style={{ textAlign: "left" }} id="company">
                        <Form.Label>Company</Form.Label>
                        <Form.Control
                          type="text"
                          id="company"
                          name="company"
                          placeholder="Company"
                          defaultValue={userData.company}
                          onChange={handleChange}
                        ></Form.Control>
                      </Form.Group>

                      <Row style={{ textAlign: "left" }}>
                        <Col>
                          <Form.Group id="firstName">
                            <Form.Label>First Name*</Form.Label>
                            <Form.Control
                              id="firstName"
                              type="text"
                              name="firstName"
                              placeholder="First Name"
                              defaultValue={userData.firstName}
                              onChange={handleChange}
                              required
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                        <Col>
                          <Form.Group id="lastName">
                            <Form.Label>Last Name*</Form.Label>
                            <Form.Control
                              type="text"
                              id="lastName"
                              name="lastName"
                              placeholder="Last Name"
                              defaultValue={userData.lastName}
                              onChange={handleChange}
                              required
                            ></Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>

                      <Form.Group style={{ textAlign: "left" }} id="phone">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                          type="text"
                          id="phone"
                          name="phone"
                          placeholder="Phone Number"
                          defaultValue={userData.phone}
                          onChange={handleChange}
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group style={{ textAlign: "left" }} id="position">
                        <Form.Label>Position</Form.Label>
                        <Form.Control
                          type="text"
                          id="position"
                          name="position"
                          placeholder="Position"
                          defaultValue={userData.position}
                          onChange={handleChange}
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group
                        style={{ textAlign: "left" }}
                        controlId="ultimateEditinCheckboxes"
                      >
                        <Form.Label>Subscription</Form.Label>

                        <Form.Control
                          style={{ marginLeft: "1vw", width: "50%" }}
                          as="select"
                          value={Subscription}
                          name={Subscription}
                          label={Subscription}
                          onChange={(e) => {
                            setSubscription(e.target.value);
                          }}
                        >
                          <option value="trial">trial</option>
                          <option value="ultimate">ultimate</option>
                          <option value="ultimatePlus">ultimatePlus</option>
                        </Form.Control>
                      </Form.Group>
                      <Form.Group
                        style={{ textAlign: "left" }}
                        controlId="topicOfInterestCheckboxes"
                      >
                        <Form.Label>Role</Form.Label>
                        <Form.Control
                          style={{ marginLeft: "1vw", width: "50%" }}
                          as="select"
                          value={role}
                          name={role}
                          label={role}
                          onChange={(e) => {
                            setRole(e.target.value);
                          }}
                        >
                          <option value="user">user</option>
                          <option value="admin">admin</option>
                        </Form.Control>
                      </Form.Group>

                      <div className="modal-footer">
                        <input
                          type="button"
                          className="btn btn-default"
                          data-dismiss="modal"
                          value="Cancel"
                        />
                        <button
                          onClick={(e) => submitForm(e)}
                          type="submit"
                          className="btn btn-success"
                        >
                          Create user
                        </button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              <svg
                style={{ float: "right", cursor: "pointer" }}
                width="45"
                height="25"
                fill="currentColor"
                className="bi bi-trash"
                viewBox="0 0 16 16"
                data-toggle="modal"
                data-target="#exampleModal"
              >
                <title>Delete user</title>
                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                <path
                  fillRule="evenodd"
                  d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                />
              </svg>
              <svg
                style={{ float: "right", cursor: "pointer" }}
                width="45"
                height="25"
                fill="currentColor"
                className="bi bi-pencil-square"
                viewBox="0 0 16 16"
                data-toggle="modal"
                data-target="#updateModal"
              >
                <title>Update user</title>
                <path d="M3.5 6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1 0-1h2A1.5 1.5 0 0 1 14 6.5v8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 14.5v-8A1.5 1.5 0 0 1 3.5 5h2a.5.5 0 0 1 0 1h-2z" />
                <path d="M7.646.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 1.707V10.5a.5.5 0 0 1-1 0V1.707L5.354 3.854a.5.5 0 1 1-.708-.708l3-3z" />
              </svg>
              <div
                className="modal fade"
                id="updateModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Update User
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to update the data of selected
                        user?
                      </p>
                      {alertMsg.updateApiResStatusCode ? (
                        <Alert variant="success" align="center">
                          The data of selected user has been updated
                          successfully, this page will be automatically reloaded
                          after 5 seconds...
                        </Alert>
                      ) : alertMsg.updateUserAPIError ? (
                        <Alert variant="danger" align="center">
                          {alertMsg.updateUserAPIError}
                        </Alert>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        // style={{ width: "7vw", height: "4vh" }}
                        type="button"
                        className="btn btn-primary"
                        onClick={updateUserByID}
                      >
                        Update User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="modal fade"
                id="exampleModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Delete User
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>Are you sure you want to delete the selected user?</p>
                      {alertMsg.deleteApiResMsg ===
                      "successfully deleted user" ? (
                        <Alert variant="success" align="center">
                          {`${alertMsg.deleteApiResMsg}, this page will be reloaded after 5 seconds...`}
                        </Alert>
                      ) : alertMsg.deleteUserAPIError ? (
                        <Alert variant="danger" align="center">
                          {alertMsg.deleteUserAPIError}
                        </Alert>
                      ) : (
                        <div></div>
                      )}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        // style={{ width: "7vw", height: "4vh" }}
                        type="button"
                        className="btn btn-primary"
                        onClick={deleteUserByID}
                      >
                        Delete User
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Alert>

            {rows ? (
              <div className={classes.root}>
                <DataGrid
                  density="compact"
                  rows={rows}
                  columns={columns}
                  rowHeight={47}
                  pageSize={15}
                  checkboxSelection
                  autoHeight={true}
                  autoWidth={true}
                  onRowSelected={(e) => {
                    setClickedRowID(e.data.id);
                    // localStorage.setItem("clickedRowID", e.data.id);
                    setExpirationDate(e.data.expirationDate);
                    // localStorage.setItem(
                    //   "expirationDate",
                    //   e.data.expirationDate
                    // );
                    // setUserRole(e.data.role);
                    //localStorage.setItem("role", e.data.role);
                  }}
                  onEditCellChangeCommitted={(e) => {
                    if (e.field === "subscription") {
                      setsubscription(e.props.value);
                      //localStorage.setItem("subscription", e.props.value);
                    }
                  }}
                  components={{
                    Toolbar: GridToolbar,
                  }}
                />
              </div>
            ) : (
              <LoadingSpinner />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default UserList;
